module.exports = __webpack_public_path__ + "images/user_logo.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user_logo.png
// module id = 379
// module chunks = 2